import { useEffect, useState } from "react";
import { FaArrowCircleUp } from "react-icons/fa";
import { AnimatePresence } from "framer-motion";
import { FloatingButton } from "./localStyle";

const FloatingScroll = ({ body }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [widthWindow, setWidthWindow] = useState(window.innerWidth);

  let ventana = document.documentElement.getElementsByClassName(body);
  const handleScroll = () => {
    if (ventana[0].scrollTop > 300) {
      setIsVisible(true);
    } else if (ventana[0].scrollTop <= 300) {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    ventana[0].scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    ventana[0]?.addEventListener("scroll", handleScroll);
    return () => ventana[0]?.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWidthWindow(window.innerWidth);
    };

    // Agrega el listener de resize cuando el componente se monta
    window.addEventListener("resize", handleResize);

    // Limpia el listener cuando el componente se desmonta
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <AnimatePresence>
      {isVisible && (
        <FloatingButton
          onClick={scrollToTop}
          aria-label="Subir"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          transition={{ duration: 0.3 }}
          style={{
            background: "var(--color-white)",
            borderRadius: "100%",
            padding: 0,
            margin: "auto",
            width: 40,
            height: 40,
          }}
        >
          <FaArrowCircleUp
            size={40}
            style={{ color: "var(--color-primary)", filter: "invert(0)" }}
          />
        </FloatingButton>
      )}
    </AnimatePresence>
  );
};

export default FloatingScroll;
